export default "__VITE_ASSET__4Uxs80P4__"